module.exports = function FetchRequest(cid, selector) {
    this.cid = cid;
    this.selector = selector;
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/fetch/fetch-request.js
// module id = 312
// module chunks = 0